jQuery(function ($) {

	function paginate(){
		$('#pagination a.page-numbers').click(function(e){
			e.preventDefault();
			var _this = $(this),
				getPaged = _this.attr('href').split('/'),
				pagedLength = getPaged.length,
				paged = getPaged[pagedLength-2];

				if(_this.parents('.default-search').length != 0){
					wineAjax(paged, 'default-search');
				}else{
					wineAjax(paged, 'ajax');
				}

		});
	}

	function wineAjax(paged, query_type){
		var checkboxes_wine_flavor = [];
		$("input[name=checkbox_wine_flavor]:checked").each(function() {
		   checkboxes_wine_flavor.push($(this).val());
		});

		var data = {
			action : 'product_wine_search',
			wine_appellation_code : searchForm.find('#select_appellation').val(),
			wine_color : searchForm.find('input[name=checkbox_color]:checked').val(),
			wine_flavor_code : checkboxes_wine_flavor,
			wine_agri : searchForm.find('#select_agri').val(),
			paged : paged,
			query_type : query_type
		};

	    $.ajax({
	        type : 'post',
	       	url : wine_search_ajax_url.ajaxurl,
	        data : data,
	        beforeSend: function() {
				searchFormSubmit.prop('disabled', true);
				loader.show();
	        },
	        success : function( response ) {
	        	var htmlResult='',
	        		pagination='';

	        	$('#no-result').hide();

	        	if(!response.no_result){
					for(var i=0; i < response.wines.length; i++){
						htmlResult += '<div class="one_column wine-container left" id="wine_'+response.wines[i].wine_id+'">';
						htmlResult +=	'<a href="'+response.wines[i].wine_permalink+'">';
						if(response.wines[i].wine_image)
							htmlResult +=	response.wines[i].wine_image;
						htmlResult +=	'	<div class="appellation">'+response.wines[i].wine_appellation+'<br>'+response.wines[i].wine_title+'</div>';
						htmlResult +=	'	<div class="terroir">'+response.wines[i].wine_terroir+'</div>';
						htmlResult += 	'</a>';
						htmlResult += '</div>';
					}

					$('#block_result').fadeOut('fast', function(){
						var block_result = $(this);
						block_result.empty();
						block_result.append(htmlResult).fadeIn('normal',function(){
							var scrollHeight = (block_result.offset().top)-($('.main_wrapper .header').height());
							$('html, body').animate({
						        scrollTop: scrollHeight
						    }, 1500);
						});
					});

					$('#pagination').html(response.pagination);
					$("#pagination .page-numbers:not(.prev, .next)" ).wrapAll( "<div class='paginate-numbers' />");

					if(query_type == 'ajax'){
						$('#pagination').removeClass('default-search');
					}

					paginate();
	        	}else{
	        		$('#pagination').html('').hide();
	        		$('#block_result').fadeOut('fast', function(){
	        			var block_result = $(this);
	        			block_result.empty();
        				var scrollHeight = (block_result.offset().top)-($('.main_wrapper .header').height());
        				$('html, body').animate({
    				        scrollTop: scrollHeight
    				    }, 1500);
	        			/*block_result.append('pas de résultats pour cette recherche').fadeIn('normal',function(){
	        				var scrollHeight = (block_result.offset().top)-($('.main_wrapper .header').height());
	        				$('html, body').animate({
        				        scrollTop: scrollHeight
        				    }, 1500);
	        			});*/
	        			$('#no-result').fadeIn('slow');
	        		});
	        	}
				searchFormSubmit.removeAttr('disabled');
				loader.hide();
	        }
	    });
	}

	paginate();

	var wineSearch = $('#block_search'),
		searchForm = wineSearch.find('form'),
		loader = searchForm.find('.producta-loading'),
		searchFormSubmit = searchForm.find('button[type=submit]');

	searchForm.submit(function(e){
		e.preventDefault();
		wineAjax(1,'ajax');
	});
});
